module.exports = __webpack_public_path__ + "img/translate.87d9508a.svg";